/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */
import { get } from 'lodash';
import { PeriodOptions, StopRepeatingOptions } from '../constants';
import { getPeriodDisplayLabel } from '../../../../components/recurrence/utils';
import {
  buildQuickSuggestions,
  buildCustomRepeatQuickSuggestions,
} from '../../../../components/recurrence/suggestions';

export default [
  {
    name: 'startDate',
    sorCreate: true,
    displayName: 'Starts On',
    description: '',
    placeholder: '',
    isCustomAttribute: false,
    customAttributeType: null,
    mandatory: false,
    unique: false,
    validation: [],
    validOptions: [],
  },
  {
    name: 'endDate',
    sorCreate: true,
    displayName: 'Due On',
    description: '',
    placeholder: '',
    isCustomAttribute: false,
    customAttributeType: null,
    mandatory: false,
    unique: false,
    validOptions: [],
    validation: [],
  },
  {
    name: 'repeatOption',
    sorCreate: true,
    attrName: 'repeatOption',
    type: 'property',
    displayName: '',
    description: '',
    placeholder: '',
    isCustomAttribute: false,
    customAttributeType: null,
    mandatory: false,
    unique: false,
    validOptions: ({ endDate }) => {
      // build the quick suggestions depending on the due date
      return buildQuickSuggestions(endDate);
    },
    validation: [
      {
        validator: 'VALID_VALUES',
        meta: [],
      },
    ],
  },
  {
    name: 'period',
    sorCreate: true,
    attrName: 'period',
    type: 'property',
    displayName: '',
    description: '',
    placeholder: '',
    isCustomAttribute: false,
    customAttributeType: null,
    mandatory: false,
    unique: false,
    validOptions: [
      {
        label: getPeriodDisplayLabel(PeriodOptions.Weekly),
        value: PeriodOptions.Weekly,
      },
      {
        label: getPeriodDisplayLabel(PeriodOptions.Monthly),
        value: PeriodOptions.Monthly,
      },
      {
        label: getPeriodDisplayLabel(PeriodOptions.Quarterly),
        value: PeriodOptions.Quarterly,
      },
      {
        label: getPeriodDisplayLabel(PeriodOptions.Yearly),
        value: PeriodOptions.Yearly,
      },
    ],
    validation: [
      {
        validator: 'VALID_VALUES',
        meta: [PeriodOptions.Weekly, PeriodOptions.Monthly, PeriodOptions.Quarterly, PeriodOptions.Yearly],
      },
    ],
  },
  {
    name: 'repeatInterval',
    sorCreate: true,
    attrName: 'repeat_interval',
    type: 'property',
    displayName: 'Due every',
    description: '',
    placeholder: '',
    isCustomAttribute: false,
    customAttributeType: null,
    mandatory: true,
    unique: false,
    validation: [
      {
        validator: 'NUMERIC',
        meta: [],
      },
      {
        validator: 'MIN_VALUE',
        meta: [1],
      },
    ],
  },
  {
    name: 'days',
    sorCreate: true,
    attrName: 'days',
    type: 'property',
    displayName: 'On',
    description: '',
    placeholder: '',
    isCustomAttribute: false,
    customAttributeType: null,
    mandatory: true,
    validOptions: [0, 1, 2, 3, 4, 5, 6],
    unique: false,
    validation: [
      {
        validator: 'REQUIRED',
        meta: ['true'],
      },
      {
        validator: 'VALID_VALUES',
        meta: [0, 1, 2, 3, 4, 5, 6],
      },
    ],
  },
  {
    name: 'repeatOn',
    sorCreate: true,
    attrName: 'repeatOn',
    type: 'property',
    displayName: 'On',
    description: '',
    placeholder: '',
    isCustomAttribute: false,
    customAttributeType: null,
    mandatory: true,
    unique: false,
    validOptions: formData => {
      const period = get(formData, 'period.value', PeriodOptions.Weekly);
      return buildCustomRepeatQuickSuggestions(formData.endDate, [period]);
    },
    validation: [
      {
        validator: 'REQUIRED',
        meta: ['true'],
      },
      {
        validator: 'VALID_VALUES',
        meta: [],
      },
    ],
  },
  {
    name: 'stopRepeating',
    sorCreate: true,
    attrName: 'stop_repeating',
    type: 'property',
    displayName: 'Ends',
    description: '',
    placeholder: '',
    isCustomAttribute: false,
    customAttributeType: null,
    mandatory: false,
    unique: false,
    validOptions: [
      {
        label: StopRepeatingOptions.Never,
        value: StopRepeatingOptions.Never,
      },
      {
        label: StopRepeatingOptions.On,
        value: StopRepeatingOptions.On,
      },
      {
        label: StopRepeatingOptions.After,
        value: StopRepeatingOptions.After,
      },
    ],
    validation: [
      {
        validator: 'VALID_VALUES',
        meta: [StopRepeatingOptions.Never, StopRepeatingOptions.On, StopRepeatingOptions.After],
      },
    ],
  },
  {
    name: 'stopOn',
    sorCreate: true,
    attrName: 'stop_on',
    type: 'property',
    displayName: '',
    description: '',
    placeholder: '',
    isCustomAttribute: false,
    customAttributeType: null,
    mandatory: false,
    unique: false,
    validation: [
      {
        validator: 'REQUIRED',
        meta: ['true'],
      },
    ],
  },
  {
    name: 'repeatTimes',
    sorCreate: true,
    attrName: 'repeat_times',
    type: 'property',
    displayName: '',
    description: '',
    placeholder: '',
    isCustomAttribute: false,
    customAttributeType: null,
    mandatory: false,
    unique: false,
    validation: [
      {
        validator: 'NUMERIC',
        meta: [],
      },
      {
        validator: 'MIN_VALUE',
        meta: [1],
      },
    ],
  },
  {
    name: 'scheduleMessage',
    sorCreate: true,
    attrName: 'schedule_message',
    type: 'property',
    displayName: '',
    description: '',
    placeholder: '',
    isCustomAttribute: false,
    customAttributeType: null,
    mandatory: false,
    unique: false,
    validation: [],
  },
  {
    name: 'endDateMessage',
    sorCreate: true,
    attrName: 'end_date_message',
    type: 'property',
    displayName: '',
    description: '',
    placeholder: '',
    isCustomAttribute: false,
    customAttributeType: null,
    mandatory: false,
    unique: false,
    validation: [],
  },
];
